import { gql } from '@apollo/client';

/**
 * ТЗ 0112 (#155) — документы (справки, лист присутствия, свободный документ).
 * Имена операций отличаются от полей бэкенда (иначе типы результата
 * схлопываются). Без `${…}`-вставок: такой шаблон codegen пропускает молча.
 */

/** Справочник шаблонов документов (Настройки → Шаблоны и выбор при выпуске). */
export const DocTemplatesListQuery = gql`
  query DocTemplatesList(
    $kind: String
    $scope: String
    $includeInactive: Boolean
  ) {
    documentTemplates(
      kind: $kind
      scope: $scope
      includeInactive: $includeInactive
    ) {
      id
      code
      name
      kind
      scope
      isActive
      legalEntityId
      legalEntityName
      version
      currentVersionId
      createdAt
      updatedAt
      updatedByName
      versions {
        id
        version
        origin
        comment
        createdAt
        createdByName
        isCurrent
      }
    }
  }
`;

/** Текст шаблона для визуального редактора (только Admin). */
export const DocTemplateEditorSourceQuery = gql`
  query DocTemplateEditorSource($id: ID!, $language: String) {
    documentTemplateEditable(id: $id, language: $language) {
      template {
        id
        code
        name
        kind
        scope
        isActive
        legalEntityId
        legalEntityName
        version
        currentVersionId
        createdAt
        updatedAt
        updatedByName
      }
      html
      tokens {
        n
        kind
        role
        code
        label
        labelPl
        removable
        placement
      }
      variables {
        code
        group
        label
        labelPl
        groupLabel
        groupLabelPl
      }
    }
  }
`;

/** Образец несохранённого текста редактора (только Admin). */
export const DocTemplateDraftSampleQuery = gql`
  query DocTemplateDraftSample($id: ID!, $html: String!) {
    documentTemplatePreviewDraft(id: $id, html: $html) {
      html
      problems {
        code
        message
        token
      }
    }
  }
`;

/** Предпросмотр документа на данных студента / группы перед выпуском. */
export const DocIssuePreviewQuery = gql`
  query DocIssuePreview(
    $templateId: ID!
    $studentId: ID
    $agreementId: ID
    $groupId: ID
    $issuePlace: String
  ) {
    previewDocument(
      templateId: $templateId
      studentId: $studentId
      agreementId: $agreementId
      groupId: $groupId
      issuePlace: $issuePlace
    ) {
      html
      numberPreview
      missingFields {
        code
        label
        labelPl
      }
      hiddenFields {
        code
        label
        labelPl
      }
      errorCode
      errorMessage
    }
  }
`;

/** История выпусков по студенту или группе. */
export const IssuedDocsHistoryQuery = gql`
  query IssuedDocsHistory($studentId: ID, $groupId: ID) {
    issuedDocuments(studentId: $studentId, groupId: $groupId) {
      id
      number
      kind
      scope
      templateId
      templateName
      templateVersion
      studentId
      studentName
      agreementId
      agreementTitle
      groupId
      groupName
      issueDate
      issuePlace
      issuedAt
      issuedByName
      missingFields
      hiddenFields
      hasFile
      sends {
        id
        sentAt
        sentTo
        sentByName
        mailboxEmail
        conversationId
      }
    }
  }
`;

/** PDF выпущенного документа (рендерится по запросу, base64). */
export const IssuedDocFileDownloadQuery = gql`
  query IssuedDocFileDownload($id: ID!) {
    issuedDocumentFile(id: $id) {
      fileName
      contentType
      contentBase64
    }
  }
`;

/**
 * ТЗ 0112 §4 — черновик письма с документом: адрес студента, тема и текст
 * по-польски, ящики «От». Ничего не отправляет. Имя ≠ полю
 * `documentSendDefaults`.
 */
export const DocSendDraftQuery = gql`
  query DocSendDraft($issuedDocumentId: ID!) {
    documentSendDefaults(issuedDocumentId: $issuedDocumentId) {
      to
      subject
      html
      mailboxEmail
      mailboxes
    }
  }
`;
